module.exports = __webpack_public_path__ + "img/Sri Lanka.301cec74.gif";